<template>
        <tr>
            <input type="hidden"
                   :name="'insurance[' + service.category_id + ']['+  service.service_id +'][sort_no]'"
                   v-model="service.sort_no">

            <input type="hidden"
                   :id="'is_sj_service_id_'+service.service_id"
                   v-model="service.service_id"
                   v-if="service.is_sj_service">

            <td class="nowrap drag_handle" width="5%"><i class="fa fa-align-justify"></i></td>
            <td width="30%">
                <input type="text"
                       :name="'insurance[' + service.category_id + ']['+  service.service_id +'][service_name]'"
                       :id="'service_name_' + service.service_id"
                       class="form-control"
                       v-model="service.service_name" maxlength="255" placeholder="サービス名">
                <label class="m-t-sm"><input type="checkbox"
                                             :name="'insurance[' + service.category_id + ']['+  service.service_id +'][public_flg]'"
                                             v-model="service.public_flg">&ensp;掲載する</label>
                <div v-if="errors.insurance_errors">
                    <p class="service_error" v-show="errors.insurance_errors.service_name[service.category_id][service.service_id]"
                       style="display: none">項目名が未入力です。</p>
                    <p class="service_error" v-show="errors.insurance_errors.contents[service.category_id][service.service_id]" style="display: none">
                        説明文が未入力です。</p>
                </div>
            </td>
            <td width="55%">
               <textarea rows="3"
                         :name="'insurance[' + service.category_id + ']['+  service.service_id +'][contents]'"
                         :id="'service_contents_' + service.service_id"
                         class="form-control"
                         v-model="service.contents" maxlength="255"
                         placeholder="サービスの説明文"></textarea>
            </td>
            <td class="no_dragover" width="10%">
                <a class="m-l-xs btn-delete" data-toggle="modal"
                   :data-target="'#dialog_delete_item_'+ insurance_key + '_' + service.service_id">
                <button class="btn btn-primary btn-xs" type="button"
                        v-if="(service_key != '0')">
                    <i class="fa fa-trash"></i>
                    削除
                </button>
                </a>
            </td>
            <!-- 削除ダイアログ -->
            <div class="modal fade inmodal" role="dialog"
                 :id="'dialog_delete_item_'+ insurance_key + '_' + service.service_id" tabindex="-1">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close"><span aria-hidden="true">×</span></button>
                            <i class="fa fa-trash modal-icon"></i>
                            <h4 class="modal-title">削除の確認</h4>
                        </div>
                        <div class="modal-body">
                            <div v-if="service.is_sj_service">
                                <p>サービスのご案内に記載の内容は、すでに損保ジャパンで募集文書申請済みで、 </p>
                                <p>募集文書番号は「サイト設定>募集文書番号」に登録済みです</p>
                                <br>
                                <p>内容を変更する場合は、再度保険会社に募集文書申請が必要となります。</p>
                                <br>
                                <p>なお、その他の保険会社から付与された募集文書番号は個別に登録をお願いいたします。</p>
                            </div>
                            <p v-show="service.service_name">『{{ service.service_name }}』を削除してもよろしいですか？</p>
                            <p v-show="!service.service_name">該当のサービスを削除してもよろしいですか？</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default pull-left"
                                    data-dismiss="modal">キャンセル
                            </button>
                            <button type="button" class="btn btn-primary"
                                    @click="emitEvent(insurance_key,service_key, '#dialog_delete_item_'+ insurance_key + '_' + service.service_id)">
                                実行する
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </tr>
</template>
<script>

export default {
    props: ['service', 'service_key', 'insurance_key', 'errors'],
    methods: {
        emitEvent(insurance_key, service_key, modal_name) {
            this.$emit('service-emit', {insurance_key: insurance_key, service_key: service_key, modal_name: modal_name })
        }
    }
}
</script>
